import { ShieldCheck, Clock, Lightning, Star } from "@phosphor-icons/react";

const ITEMS = [
  { icon: Star, label: "4.9/5 Rating", weight: "fill" },
  { icon: ShieldCheck, label: "Licensed & Insured", weight: "fill" },
  { icon: Lightning, label: "60-Min Response", weight: "fill" },
  { icon: Clock, label: "24/7 Available", weight: "fill" },
];

export default function TrustBar({ variant = "dark" }) {
  const cls =
    variant === "dark"
      ? "bg-[#1B2A4A] text-white"
      : "bg-[#F8FAFC] text-[#1B2A4A] border-y border-[#E2E8F0]";
  return (
    <div
      data-testid="trust-bar"
      className={`${cls} py-4 px-4 w-full`}
    >
      <div className="mx-auto max-w-7xl flex flex-wrap items-center justify-center gap-x-6 gap-y-2 md:gap-x-10 text-xs md:text-sm font-bold uppercase tracking-wider font-display">
        {ITEMS.map((it) => (
          <span
            key={it.label}
            className="inline-flex items-center gap-2"
            data-testid={`trust-badge-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            <it.icon
              size={18}
              weight={it.weight}
              className={variant === "dark" ? "text-[#FF6B00]" : "text-[#FF6B00]"}
            />
            {it.label}
          </span>
        ))}
      </div>
    </div>
  );
}
